import { Bbox, BboxCanvas, Skeleton } from '@/components/ui'
import {
  useCurrentBlockIndex,
  useCurrentPage,
  useDocumentActions,
  useScrollBlockIntoView,
} from '@/modules/documents'
import { cn } from '@/utils'

interface PagePreviewProps {
  isLoading: boolean
  showBlocks: boolean
  showThumbnails: boolean
  disableMouseEvents?: boolean
}

export const PagePreview = ({
  isLoading,
  showBlocks,
  showThumbnails,
  disableMouseEvents = false,
}: PagePreviewProps) => {
  const currentBlockIndex = useCurrentBlockIndex()
  const currentPage = useCurrentPage()
  const { setCurrentBlock } = useDocumentActions()
  const { blockRefs } = useScrollBlockIntoView()

  return (
    <div
      className={cn(
        'relative flex overflow-y-auto flex-1 items-start justify-center rounded-lg rounded-t-none border bg-white',
        showThumbnails && 'rounded-l-none',
      )}
    >
      {isLoading ? (
        <Skeleton className="h-full w-full rounded-lg" />
      ) : (
        currentPage && (
          <BboxCanvas
            key={currentPage.number}
            bbox={currentPage.bbox}
            preview={currentPage.preview}
            ariaLabel={`Page ${currentPage.number}`}
            className="w-full rounded-lg"
          >
            {currentPage.blocks.map((block, i) => (
              <Bbox
                key={block.bbox.join(',')}
                bbox={block.bbox}
                ref={(el) => {
                  blockRefs.current[i] = el
                }}
                className={cn(
                  'stroke-blue-200/70 fill-blue-300/10 transition-all',
                  !showBlocks && 'opacity-0',
                  currentBlockIndex === i &&
                    'opacity-100 stroke-brand/70 fill-brand/10',
                )}
                strokeWidth="2"
                rx="2"
                onMouseEnter={() => !disableMouseEvents && setCurrentBlock(i)}
                onMouseLeave={() =>
                  !disableMouseEvents && setCurrentBlock(null)
                }
              />
            ))}
          </BboxCanvas>
        )
      )}
    </div>
  )
}
